import React from "react";
import "./HoroscopesCard.scss";
import { HoroscopesIcon } from "../HoroscopesIcon/HoroscopesIcon";
import { HoroscopeIconCategory, HoroscopeIconType } from "../HoroscopesIcon/HoroscopesIcon-Constants";

interface HoroscopeCardProps {
  icon?: HoroscopeIconType | HoroscopeIconCategory;
  category: string;
  sign?: string;
  date: string;
  text: string;
}

export const HoroscopeCard: React.FC<HoroscopeCardProps> = ({
  icon,
  category,
  sign,
  date,
  text,
}) => {
  return (
    <div className="horoscope-card">
      <div className="horoscope-card__header">
        <div className="horoscope-card__icon">
          <HoroscopesIcon type={icon || HoroscopeIconType.aries} />
        </div>
        <div>
          <div className="horoscope-card__title title-xs">
            {sign ? `${category} | ${sign}` : category}
          </div>
          <div className="horoscope-card__date">{date}</div>
        </div>
      </div>
      <div className="horoscope-card__body body-sm">{text}</div>
    </div>
  );
};
